import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import customConfirmationGT from "../../../../src/content/giving-tuesday/customConfirmation";
import * as React from 'react';
export default {
  SingleDonationForm,
  customConfirmationGT,
  React
};